import { render } from "./MarketplaceAccountSidebarMenu.vue?vue&type=template&id=354a356c&lang=html"
import script from "./MarketplaceAccountSidebarMenu.vue?vue&type=script&lang=js"
export * from "./MarketplaceAccountSidebarMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__